import React from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import ToolbarBackIcon from '../Icons/ToolbarBackIcon';

const Toolbar = ({
  actions, back, buttons, className, onBack, title, ...others
}) => (
  <div
    className={cns(
      'toolbar',
      className,
    )}
    {...others}
  >
    {back && (
      <div
        className="toolbar__backBtn"
        onClick={onBack}
        role="presentation"
      >
        <ToolbarBackIcon className="toolbar__backIcon" />
      </div>
    )}
    <div className="toolbar__title"><span>{title}</span></div>
    <div className="toolbar__actions">{actions}</div>
    <div className="toolbar__buttons">{buttons}</div>
  </div>
);

Toolbar.propTypes = {
  /** Componente contenente i bottoni da visualizzare */
  actions: PropTypes.element,
  /** Indica se visualizzare il tasto di back */
  back: PropTypes.bool,
  /** Componente contenente i bottoni da visualizzare */
  buttons: PropTypes.element,
  /** Classi css personalizzate da aggiungere al componente */
  className: PropTypes.string,
  /**
   * Funzione invocata al click del tasto back:
   * ```
   *  onBack(event)
   * ```
   * dove:
   * * *event*: evento scatenante
   */
  onBack: PropTypes.func,
  /** Il titolo della toolbar */
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
};

Toolbar.defaultProps = {
  actions: null,
  back: false,
  buttons: null,
  className: '',
  onBack: null,
  title: '',
};

export default Toolbar;
